import {applyResultCart}     from "@Common/logic/checkout/common/apply-result-cart";
import {cnv, setNestedValue} from "@Common/utils/arr-path";
import {chain}               from "@Common/utils/fs";
import {omit}                from "@Common/utils/objects";

export const BillingAccountStoreActions = ({clearCards, apis}) => ({
    removeBillingAccounts: () => removeBillingAccounts({apis}),
    addBillingAccount: ({billingId, fields}) => addBillingAccount({billingId, fields}, {apis, clearCards}),
    updateBillingAccountFields: ({billingId, fields}) => updateBillingAccountFields({billingId, fields}, {apis}),
});

const applyCartUpdate = (fn, {apis}) => ({
    action: async (cart) => {
        const resultCart:any = await apis.next.cart.updateCart(chain(
            cart,
            fn,
            (_) => omit(_, ["items", "appliedPayments"]),
        ));

        return resultCart.errors || (resultCart.paymentErrors && !Array.isArray(resultCart.paymentErrors)) ? {
            error: resultCart,
        } : {
            change: applyResultCart(resultCart),
        };
    },
});

const removeBillingAccounts = ({apis}) => applyCartUpdate(
    (_) => setNestedValue(
        _, ["removePayments", "billing"],
        _?.appliedPayments?.billing
    ),
    {apis},
);

const addBillingAccount = ({billingId, fields}, {apis, clearCards}) => applyCartUpdate(
    (_) => chain(
        _,

        (_) => !clearCards ? _ : (
            setNestedValue(_, ["removePayments", "creditCards"], _?.appliedPayments?.creditCards)
        ),

        (_) => setNestedValue(_, ["payments", "billing"],
            _.items.map((item) => ({
                itemId: item.itemId,
                billingId,
                ...fields,
            })),
        ),
    ),
    {apis},
);

const updateBillingAccountFields = ({billingId, fields}, {apis}) => applyCartUpdate(
    (_) => chain(
        _,

        (_) => setNestedValue(
            _, ["removePayments", "billing"],
            _?.appliedPayments?.billing.filter((billing) => billing.billingId == billingId)
        ),

        (_) => cnv(_, ["payments", "billing"], (billings) => (
            _.items.map((item) => ({
                ...fields,
                itemId: item.itemId,
                billingId,
            }))
        )),
    ),
    {apis},
);
